import { createSlice } from '@reduxjs/toolkit';

import { profileApi } from './profile-api';

import type { TUserInfoResponse } from './types';

const initialState: TUserInfoResponse = {
  id: 0,
  email: '',
  name: '',
  role: 'user',
  created: '',
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    build
      .addMatcher(profileApi.endpoints.getUserInfo.matchFulfilled, (state, action) => {
        state.id = action.payload.id;
        state.email = action.payload.email;
        state.name = action.payload.name;
        state.role = action.payload.role;
        state.created = action.payload.created;
      })
  },
});
